module.exports = __webpack_public_path__ + "img/settings.1a5b9c10.svg";